// extracted by mini-css-extract-plugin
export default {"container":"ScreenSizeIncompatibility_container__LMBls","container__content":"ScreenSizeIncompatibility_container__content__o-DoM"};